import { useMobile } from "@with-nx/hooks-n-helpers";
import { DesignedButton, Rule } from "@with-nx/simple-ui/atoms";
import {
  AutomaticGetStarted,
  CatalogLayout,
  ReusableGradientHero,
  ReusableSlantedContainer,
} from "@with-nx/simple-ui/organisms";
import { Col, Row } from "antd";
import { Box } from "simple-effing-primitive-layout";

export default function Projector({ resolvedUrl }) {
  const mobile = useMobile();

  return (
    <CatalogLayout
      transparentFixedNavBar
      title={`Broadway Media - BodyMics Rentals`}
      description="Elevate Your Theatre Experience with Professional Wireless Microphone Systems"
      resolvedUrl={resolvedUrl}
    >
      <ReusableGradientHero
        src={"/assets/stage-gear/hero-stage-gear-microphones.png"}
        backdrop="/assets/stage-gear/background-gradient.png"
        slanted={false}
        span={24}
      >
        <Box parse="d:flex fd:column a:center j:center">
          <Rule parse="!hxl ta:center mb:24">
            <img
              style={{
                width: mobile ? "80%" : "25%",
                height: "auto",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              alt="BodyMics - StageGear"
              src="/assets/stage-gear/stage-gear-bodymics-logo.png"
            />
          </Rule>

          <Rule parse="!hxl ta:center mb:24">
            Elevate Your Theatre Experience with <br /> Professional Wireless
            Microphone Systems
          </Rule>

          <Rule parse="!pm d:block mb:36 ta:center" color="var(--font1)">
            Amplify your performance with cutting-edge technology and superior
            customer service, <br /> ensuring an{" "}
            <b>unforgettable production experience!</b>
          </Rule>
        </Box>
      </ReusableGradientHero>
      <ReusableSlantedContainer gradient={["#181D25", "transparent"]}>
        <div className="container">
          <Row gutter={[18, 26]} justify="center">
            <Col xs={24} sm={24} md={18} lg={16}>
              <Row gutter={[18, 36]}>
                <Col xs={24}>
                  <Box
                    parse="d:block mb:24"
                    element="a"
                    native={{
                      href: "https://playbill.com/article/broadway-media-acquires-bodymics",
                      target: "_blank",
                      rel: "nofollow",
                    }}
                  >
                    <Rule parse="!dt d:block ta:center c:?font1 mb:12">
                      “Broadway Media Acquires BodyMics”
                    </Rule>
                    <Rule parse="!lm d:block ta:center c:?font3 mb:12">
                      LOGAN CULWELL-BLOCK for PLAYBILL | FEBRUARY 01, 2024
                    </Rule>
                    <img
                      alt="Playbill"
                      src="/assets/stage-gear/playbill-logo.png"
                      style={{
                        width: "50%",
                        height: "auto",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    />
                  </Box>
                </Col>
                <Col xs={24}>
                  <Rule parse="!pl d:block ta:center">
                    <b>BodyMics Wireless Microphone Systems</b> are crafted with
                    precision, featuring industry-leading brands such as Shure,
                    Sennheiser, Lectrosonics, and Creative Audio Technology.
                    Immerse yourself in an unparalleled sound quality that
                    amplifies your performance, ensuring professional audio for
                    an{" "}
                    <b>
                      <i>unforgettable audience experience</i>
                    </b>
                    .
                  </Rule>
                </Col>
                <Col xs={24}>
                  <Box
                    parse="pa:24 br:3"
                    border="3px solid rgba(255,255,255,0.85)"
                  >
                    <Rule parse="!hm d:block mb:12">
                      Bodymics is now officially part of the Broadway Media
                      family!
                    </Rule>
                    <Rule parse="!pl d:block mb:12">
                      I’m delighted to share the exciting news that Broadway
                      Media has acquired BodyMics, a brand recognized for its
                      excellence in wireless microphone equipment, exceptional
                      customer service, and meticulous attention to detail.
                    </Rule>
                    <Rule parse="!pl d:block mb:12">
                      As we integrate BodyMics into our StageGear division, we
                      are pleased to unveil an upgraded range of BodyMics
                      Wireless Microphone Systems. Our dedicated team has worked
                      to streamline the offerings into three distinct setups: an{" "}
                      <b>Economy option</b> featuring a pre-racked mixer, a{" "}
                      <b>Standard option</b> showcasing Shure systems, and a{" "}
                      <b>Premium Professional Lectrosonics option</b>.
                    </Rule>
                    <Rule parse="!pl d:block mb:12">
                      In line with our unwavering commitment to exceptional care
                      and support, each rental package will now include
                      additional microphones in various skin tones, offering
                      added flexibility. Just like all StageGear rentals,
                      customers can enjoy hassle-free weekly rentals and
                      complimentary shipping.
                    </Rule>
                    <Rule parse="!pl d:block mb:12">
                      We are committed to enhancing your experience, maintaining
                      trust, and carrying forward the BodyMics legacy
                      established by its founder, Rod Reilly, which has defined
                      audio excellence for nearly two decades.{" "}
                    </Rule>
                    <Rule parse="!pl d:block mb:36">
                      Welcome to Broadway Media!
                    </Rule>
                    <img
                      alt="Quentin Sanford"
                      src="/assets/stage-gear/president-signature.png"
                      style={{
                        height: 96,
                        width: "auto",
                        display: "block",
                        marginBottom: 12,
                        filter: "invert(1)",
                      }}
                    />
                    <Rule parse="!ll d:block mb:6">Quentin Sanford</Rule>
                    <Rule parse="!lm d:block mb:6 c:?font3">
                      President and Founder
                    </Rule>
                    <Rule parse="!lm d:block c:?font4">Broadway Media</Rule>
                  </Box>
                  <Box parse="d:flex a:center j:flex-end">
                    <DesignedButton
                      label="View All Products"
                      href="/stage-gear/wirelesssystems"
                      theme="tetriary"
                      properties={{
                        top: 12,
                      }}
                    />
                  </Box>
                </Col>
                <Col xs={24}>
                  <Rule parse="!ht d:block ta:center" color="var(--font2)">
                    Our pre-racked wireless microphone systems provide
                    budget-friendly plug-and-play solutions, while offering a
                    diverse range of microphone options to suit your unique
                    needs
                  </Rule>
                </Col>
              </Row>
            </Col>
          </Row>

          <AutomaticGetStarted />
        </div>
      </ReusableSlantedContainer>
    </CatalogLayout>
  );
}

export const getServerSideProps = async ({ resolvedUrl }) => {
  return {
    props: {
      resolvedUrl,
    },
  };
};
